export default function removeCurrentMarks(editor) {
  return editor.value.marks.reduce(function (memoEditor, mark) {
    return memoEditor.removeMark(mark);
  }, editor);
}